import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { SITE_URL } from "@opensea/utils";
import { useTranslations } from "next-intl";
import { getCollectionOverviewUrl } from "@/components/collection/utils";
import { useCreateCalendarEventFragment } from "./use-create-calendar-event.fragment";
export function useCreateCalendarEvent(t0) {
  const $ = _c(4);
  const {
    collectionName,
    collectionSlug
  } = t0;
  const t = useTranslations("useCreateCalendarEvent");
  let t1;
  if ($[0] !== collectionName || $[1] !== collectionSlug || $[2] !== t) {
    t1 = stageKey => {
      const stage = readFragment(useCreateCalendarEventFragment, stageKey);
      return {
        title: t("title", {
          collectionName: collectionName ?? "OpenSea drop",
          stageLabel: stage.label || t("publicStage")
        }),
        description: t("description", {
          url: `${SITE_URL.href}${getCollectionOverviewUrl(collectionSlug ?? "")}`
        }),
        start: new Date(stage.startTime),
        end: new Date(stage.endTime)
      };
    };
    $[0] = collectionName;
    $[1] = collectionSlug;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}